interface BuckleImageType {
  elegant: string | null;
  sporty: string | null;
}
export interface BuckleDataType {
  images: BuckleImageType;
  key: string;
}

export const buckleTableList = [
  {
    key: 'tangType',
    images: {
      elegant: 'buckle/tang.jpg',
      sporty: 'buckle/tang-2.jpg',
    },
  },
  {
    key: 'doubleTangType',
    images: {
      elegant: null,
      sporty: 'buckle/double-tang.jpeg',
    },
  },
  {
    key: 'folding',
    images: {
      elegant: 'buckle/folding.jpg',
      sporty: null,
    },
  },
  {
    key: 'pushButtonFoldingClasp',
    images: {
      elegant: null,
      sporty: 'buckle/push-button.jpg',
    },
  },
];
